import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faHeart } from '@fortawesome/free-solid-svg-icons';
import { getDeceasedInfos, getDeceasedCondolences } from '../api/deceased_req';
import '../style/CondolencesList.css';

export default function CondolencesList() {
    const { id, agencyId} = useParams();
    const navigate = useNavigate();
    const [deceased, setDeceased] = useState(null);
    const [condolences, setCondolences] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            const [deceasedData, condolencesData] = await Promise.all([
                getDeceasedInfos(id),
                getDeceasedCondolences(id)
            ]);

            setDeceased(deceasedData);

            console.log('Condolences API response:', condolencesData);

            // Handle different API response formats
            if (Array.isArray(condolencesData)) {
                setCondolences(condolencesData);
            } else if (condolencesData && typeof condolencesData === 'object') {
                // Try to extract array from common keys (note: API uses 'condoleances' with 'e')
                const dataArray = condolencesData.condoleances || condolencesData.data || condolencesData.condolences || Object.values(condolencesData);
                console.log('Extracted condolences array:', dataArray);
                setCondolences(Array.isArray(dataArray) ? dataArray : []);
            } else {
                setCondolences([]);
                console.error('Error fetching data');
                setCondolences([]);
            }

            setLoading(false);
        };

        fetchData();
    }, [id]);

    if (loading) {
        return (
            <div className="condolences-loading">
                <p>Chargement des condoléances...</p>
            </div>
        );
    }

    if (!deceased) {
        return (
            <div className="condolences-error">
                <h2>Erreur de chargement</h2>
                <button className="back-button" onClick={() => navigate(`/avis-deces/${agencyId}/1/${deceased.id}`)}>
                    <FontAwesomeIcon icon={faArrowLeft} />
                    Retour à l'avis
                </button>
            </div>
        );
    }

    const mainColor = deceased.main_color || '#5d4a92';

    return (
        <div className="condolences-container" style={{ backgroundColor: `${mainColor}10` }}>
            <div className="condolences-wrapper">
                <button
                    className="back-button"
                    style={{ backgroundColor: mainColor }}
                    onClick={() => navigate(`/avis-deces/${agencyId}/1/${deceased.id}`)}
                >
                    <FontAwesomeIcon icon={faArrowLeft} />
                    Retour à l'avis
                </button>

                <div className="condolences-header">
                    <h1 style={{ color: mainColor }}>Condoléances</h1>
                    <p className="condolences-for">
                        Pour {deceased.full_name_long || `${deceased.first_name} ${deceased.last_name}`}
                    </p>
                </div>

                {condolences.length === 0 ? (
                    <div className="no-condolences">
                        <FontAwesomeIcon icon={faHeart} style={{ color: mainColor }} />
                        <p>Aucune condoléance pour le moment.</p>
                        <p className="no-condolences-subtitle">Soyez le premier à partager vos condoléances.</p>
                    </div>
                ) : (
                    <div className="condolences-list">
                        {condolences.map((condolence, index) => {
                            // Build full name from civility, first_name, and last_name
                            const fullName = [
                                condolence.civility,
                                condolence.first_name,
                                condolence.last_name
                            ].filter(Boolean).join(' ') || 'Anonyme';

                            return (
                                <React.Fragment key={condolence.id || index}>
                                    <div className="condolence-item" style={{ borderLeft: `4px solid ${mainColor}` }}>
                                        <div className="condolence-header">
                                            <h3>{fullName}</h3>
                                            {condolence.date && (
                                                <span className="condolence-date">
                                                    {new Date(condolence.date.date).toLocaleDateString('fr-FR', {
                                                        day: 'numeric',
                                                        month: 'long',
                                                        year: 'numeric'
                                                    })}
                                                </span>
                                            )}
                                        </div>
                                        <p className="condolence-message">{condolence.message}</p>
                                    </div>
                                    {index < condolences.length - 1 && (
                                        <div className="condolence-separator">
                                            <img src="/assets/enluminure.png" alt="" style={{ height: '40px', width: 'auto', opacity: 0.6 }} />
                                        </div>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
}
